import React from 'react';
import { FormProvider, SubmitHandler, useForm } from 'react-hook-form';
import { authenticationSlice } from '@cp/shared/api/core';
import { useDispatch } from 'react-redux';
import { Box } from '@cp/ds/src/components/box';
import { Stack } from '@cp/ds/src/components/stack';
import { FormField } from '@cp/ds/src/components/form';
import { Typography } from '@cp/ds/src/components/typography';
import { LogoIcon } from '@cp/ds/src/icons/logo';
import { AppModalAction, ModalActions } from '@cp/ds/src/components/modalLayout';
import { useApiServerErrorHandler } from 'src/app/shared/hooks/useApiServerErrorHandler';
import { resultFromRTK } from '@cp/shared/form';
import { coreAdminAuthApi } from '../api';

export interface LoginFormModel {
  phoneNumber: string;
  password: string;
}

export const LoginForm: React.FC = () => {
  const dispatch = useDispatch();
  const [auth] = coreAdminAuthApi.useAuthMutation();
  const form = useForm<LoginFormModel>({
    defaultValues: {
      phoneNumber: '',
      password: '',
    },
  });
  const handleApiServerError = useApiServerErrorHandler();

  const onSubmit: SubmitHandler<LoginFormModel> = async (values) => {
    try {
      const response = await resultFromRTK(auth(values));
      response
        .tap((data) => {
          dispatch(authenticationSlice.actions.setToken(data.token));
        })
        .tapError((error) => handleApiServerError(error, { form, formFieldNameForCommonErrors: 'phoneNumber' }));
    } catch (err) {
      console.error(err);
    }
  };
  const actions = React.useMemo<AppModalAction[]>(
    () => [
      {
        title: 'Войти',
        variant: 'primary',
        color: 'pink',
        buttonProps: {
          type: 'submit',
          sx: {
            width: 1,
          },
        },
      },
    ],
    [],
  );

  return (
    <Stack sx={{ height: '100vh', alignItems: 'center', justifyContent: 'center' }}>
      <FormProvider {...form}>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 4.75 }}>
          <LogoIcon color="brand pink" sx={{ fontSize: '3rem' }} />
          <Typography sx={{ typography: 'h4', pl: 1 }}>Войти</Typography>
        </Box>
        <Stack
          component="form"
          noValidate
          onSubmit={form.handleSubmit(onSubmit)}
          spacing={2.5}
          sx={{ maxWidth: 320, width: 1, minWidth: 200, px: 2.5 }}
        >
          <FormField autoFocus name="phoneNumber" placeholder="Номер телефона" required type="phone" />
          <FormField name="password" placeholder="Пароль" required type="password" />
          <ModalActions actions={actions} sx={{ px: 0 }} />
        </Stack>
      </FormProvider>
    </Stack>
  );
};
LoginForm.displayName = 'LoginForm';
